import { NavLink, Outlet } from 'react-router-dom';
import { copy } from '../copy/es';
import { useSesion } from './sesion';

/** Card layout from mockup screens 2 and 3: dark header with the logo pill, tabs inside the body. */
export function AdminShell() {
  const { usuario, salir } = useSesion();
  const pestanas = [
    { a: '/admin/cargue', t: copy.admin.menu.cargue },
    { a: '/admin/publicacion', t: copy.admin.menu.publicacion },
    { a: '/admin/entregas', t: copy.admin.menu.entregas },
    ...(usuario?.rol === 'operador'
      ? [
          { a: '/admin/descargas', t: copy.admin.menu.descargas },
          { a: '/admin/usuarios', t: copy.admin.menu.usuarios },
        ]
      : []),
    { a: '/admin/configuracion', t: copy.admin.menu.configuracion },
  ];
  return (
    <div className="stage">
      <section className="screen">
        <div className="card">
          <div className="p-head">
            <span className="logo-wrap">
              <img className="logo" src="/coninsa-logo.svg" alt="Coninsa" />
            </span>
            <div className="right">
              <div className="t">
                {copy.admin.titulo} · {usuario?.correo}
                <button className="salir" onClick={() => void salir()}>
                  {copy.admin.salir}
                </button>
              </div>
              <div className="by">{copy.app.gobernadoPor.toUpperCase()}</div>
            </div>
          </div>
          <div className="p-body">
            <nav className="tabs">
              {pestanas.map((p) => (
                <NavLink key={p.a} to={p.a} className={({ isActive }) => (isActive ? 'on' : '')}>
                  {p.t}
                </NavLink>
              ))}
            </nav>
            <Outlet />
          </div>
        </div>
        <div className="foot">{copy.app.pie}</div>
      </section>
    </div>
  );
}
